import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { StockService } from '../../../stock.service';
import { NgbActiveModal, NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Medicion } from '@shared/models/stock/Medicion';
import { MessageService } from '@shell/message.service';
import { Tanque } from '@shared/models/stock/Tanque';
import { UsuarioService } from '@account/usuario.service';
import { MedicionesService } from '../../../mediciones.service';
import { AbastecedoraService } from '@stock/abastecedoras.service';
import { SharedService } from '@shared/shared.service';
import { CalculosService } from '@shared/calculos.service';
import { Producto } from '@shared/models/abm/Producto';
import { ProductoService } from '@abm/producto/producto.service';
import { Abastecedora } from '@shared/models/stock/Abastecedora';
import { ErrorModel } from '@shared/models/ErrorModel';
import { Aeroplanta } from '@shared/models/cierreTurno/Aeroplanta';

@Component({
  selector: 'app-nueva-medicion',
  templateUrl: './nueva-medicion.component.html',
  styleUrls: ['./nueva-medicion.component.css']
})
export class NuevaMedicionComponent implements OnInit {
  [x: string]: any;
  esRecepcionContingencia: boolean;
  @Input() tanques: Tanque[];
  @Input() aeroplanta: Aeroplanta;
  @Input() codigoProducto?: string;

  esValidaDensidad: boolean = true;
  esDensidadMin: any;
  esDensidadMax: any;
  medicionRecibida: Medicion;
  calculandoCantidadNeta: boolean = false;
  guardando: boolean;
  modelFechaMedicion: NgbDateStruct;
  modelHoraLlegada: any;
  varilladoOriginal: number;
  temperaturaOriginal: number;
  nivelAguaOriginal: number;
  mostrarMensajeAlerta: boolean = false;
  tanqueGraduacion: boolean = false;
  form: UntypedFormGroup;
  obteniendoMediciones: boolean = false;
  abastecedoras: Abastecedora[];
  medicionesParaTanque: boolean = true;
  productos: Producto[] = [];
  obteniendoAbastecedoras: boolean = false;
  productoSeleccionado: Producto;
  datosCintelink: boolean = false;
  fechaHoraMedicionCintelink: string;

  constructor(
    private calendar: NgbCalendar,
    private abastecedoraService: AbastecedoraService,
    private messageService: MessageService,
    private formBuilder: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private usuarioService: UsuarioService,
    private stockService: StockService,
    private medicionesService: MedicionesService,
    private productoService: ProductoService,
    private sharedService: SharedService,
    private calculoService: CalculosService) {

  }

  ngOnInit() {
    this.getProductos();
    this.medicionesParaTanque = true;
    this.getAbastecedoras();
    this.archivoDeDensidad = this.leerArchivo();
    this.crearFormulario();
    this.inicializarComponente();
    this.vaciarCampos();

    if (this.esRecepcionContingencia && this.codigoProducto) {
      this.productoService.obtenerProductos().subscribe(result => {
        this.productoSeleccionado = result.find(
          p => p.codigoProducto === this.codigoProducto
        );
      });
    }
  }

  // form

  crearFormulario() {
    this.form = this.formBuilder.group({
      tanqueFormControl: ['', Validators.required],
      cantidadNaturalFormControl: ['', Validators.required],
      cantidad15FormControl: [''],
      nivelVarilladoFormControl: ['', Validators.required],
      temperaturaFormControl: new UntypedFormControl(null, [Validators.required, this.temperaturaValidator]),
      densidadFormControl: ['', Validators.required],
      nivelDeAguaFormControl: ['', Validators.required],
      fechaFormControl: ['', Validators.required],
      abastecedoraFormControl: new UntypedFormControl({ value: null }, Validators.required),
      horaFormControl: ['', Validators.required],
    });

    this.form.setValidators(this.formValidator);

    if (this.esRecepcionContingencia) {
      this.form.get('nivelDeAguaFormControl').clearValidators();
      this.form.get('nivelVarilladoFormControl').clearValidators();
      this.form.get('cantidadNaturalFormControl').enable();
      this.form.get('temperaturaFormControl').enable();
      this.form.get('densidadFormControl').enable();

      this.datosCintelink = false;
      this.tanqueGraduacion = false;
    } else {
      this.form.get('nivelDeAguaFormControl').setValidators(Validators.required);
      this.form.get('nivelVarilladoFormControl').setValidators(Validators.required);
    }

    this.form.get('nivelDeAguaFormControl').updateValueAndValidity();
    this.form.get('nivelVarilladoFormControl').updateValueAndValidity();
  }

  inicializarComponente() {
    this.tanqueGraduacion = this.tanques[0].tieneGraduacion;
    this.verificarGraduacion(0);
    this.modelFechaMedicion = this.calendar.getToday();
    const horaActual = new Date();
    this.modelHoraLlegada = { hour: horaActual.getHours(), minute: horaActual.getMinutes(), second: horaActual.getSeconds() };
    this.guardando = false;
  }
  getProductos() {
    this.productoService.obtenerProductos()
      .subscribe(result => {
        this.productos = result;
      });
  }

  // validaciones
  formValidator(group: UntypedFormGroup): any {
    if (group) {
      const fechaRegistro = group.get("fechaFormControl").value;
      const horaRegistro = group.get("horaFormControl").value;
      const fecha = new Date(fechaRegistro.year, fechaRegistro.month - 1, fechaRegistro.day, horaRegistro.hour, horaRegistro.minute);
      const ahora = new Date();
      if (fecha > ahora) {
        return { fechaMedicionMayorAhora: true };
      }
      return null;
    }
  }

  compareProductos(p1: any, p2: any): boolean {
    return p1 && p2 ? p1.codigoProducto === p2.codigoProducto : p1 === p2;
  }

  temperaturaValidator(control: UntypedFormControl) {
    if (control.value > 100) {
      return { temperaturaFueraDeRango: true };
    }
    if (control.value < -50) {
      return { temperaturaFueraDeRango: true };
    }
    return null;
  }


  // llamadas al service
  guardar() {
    this.guardando = true;
    if (!this.densidadValida()) {
      this.messageService.showErrorMessage("La densidad debe estar entre el rango [" + this.productoSeleccionado.densidadMin + "," + this.productoSeleccionado.densidadMax + "]");
      this.guardando = false;
      return;
    }
    const medicion = new Medicion();

    medicion.codigoContenedor = this.tanqueFormControl.value.codigo;
    medicion.nivelNatural = Number((this.cantidadNaturalFormControl.value == '' ? 0 : this.cantidadNaturalFormControl.value));
    medicion.varillado = Number(this.nivelVarilladoFormControl.value);
    medicion.temperatura = Number(this.temperaturaFormControl.value);
    console.log(this.densidadFormControl.value);
    console.log(Number(this.densidadFormControl.value));
    medicion.densidad =  Number(String(this.densidadFormControl.value ?? '').replace(',', '.')) ;
    medicion.nivelAgua = this.esRecepcionContingencia ? null : Number(this.nivelDeAguaFormControl.value);
    medicion.fechaHora = this.convertUTCDateToLocalDate(this.formatDate(this.fechaFormControl.value.year, this.fechaFormControl.value.month, this.fechaFormControl.value.day, this.horaFormControl.value.hour, this.horaFormControl.value.minute));
    medicion.username = this.usuarioService.getUsernameByName();
    medicion.nivel = Number(this.calculoService.obtenerCTLNuevo(medicion.temperatura, medicion.densidad, medicion.nivelNatural));
    if (!this.esRecepcionContingencia) {
      this.medicionesService.crearMedicion(medicion)
        .subscribe(medicion => {
          this.activeModal.close(medicion);
          this.guardando = false;
          this.messageService.showSuccessMessage("Se registró correctamente la medición");
        },
          () => {
            this.guardando = false;
            this.messageService.showErrorMessage("Error al guardar medicion.");
          });
    } else {
      this.activeModal.close(medicion);
      this.guardando = false;
      return medicion
    }
  }

  formatDate(year, month, day, hour, minute): Date {
    return new Date(year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':00');
  }

  convertUTCDateToLocalDate(date) {
    const newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    return newDate;
  }

  varilladoModificado() {
    const varilladoActual = this.form.get('nivelVarilladoFormControl')?.value?.toString() ?? '';
    if (varilladoActual !== this.varilladoOriginal?.toString() && this.datosCintelink) {
      this.messageService.showWarningMessage("El valor del varillado no coincide con el de la telemedición", true);
    }
  }

  temperaturaModificada() {
    const temperaturaActual = this.form.get('temperaturaFormControl')?.value?.toString() ?? '';
    if (temperaturaActual !== this.temperaturaOriginal?.toString() && this.datosCintelink) {
      this.messageService.showWarningMessage("El valor de la temperatura no coincide con el de la telemedición", true);
    }
  }

  nivelDelAguaModificado() {
    const nivelAguaActual = this.form.get('nivelDeAguaFormControl')?.value?.toString() || undefined;
    if (nivelAguaActual !== this.nivelAguaOriginal?.toString() && this.datosCintelink) {
      this.messageService.showWarningMessage("El valor del nivel del agua no coincide con el de la telemedición", true);
    }
  }

  onSeleccionoTanque(event) {
    this.obteniendoMediciones = true;
    this.vaciarCampos();
    const tanqueSeleccionado = this.form.get('tanqueFormControl')?.value;
    if (this.aeroplanta.obtieneTelemediciones && !this.esRecepcionContingencia) {
      this.datosCintelink = true;
      this.medicionesService.getMedicion(tanqueSeleccionado.codigo)
        .subscribe(result => {
          this.medicionRecibida = result;
          if (result === null) this.datosCintelink = false;
          this.completarCampos(this.datosCintelink);
          this.obteniendoMediciones = false;
        }, (error: ErrorModel) => {
          this.messageService.showWarningLongMessage(`${error.message} \n ${error.description}`);
          this.datosCintelink = false;
          this.obteniendoMediciones = false;
        });
    } else {
      this.completarCampos(false);
      this.obteniendoMediciones = false;
    }
    this.verificarGraduacion(event.target.selectedIndex);
    this.recalcularVolumenes();
  }

  completarCampos(datosCintelink) {
    const medicion = datosCintelink ? this.medicionRecibida : {
      varillado: 0,
      nivelNatural: 0,
      temperatura: 0,
      nivelAgua: 0
    };

    this.nivelVarilladoFormControl.setValue(medicion.varillado);
    this.cantidadNaturalFormControl.setValue(medicion.nivelNatural);
    this.temperaturaFormControl.setValue(medicion.temperatura);
    this.nivelDeAguaFormControl.setValue(medicion.nivelAgua ?? '');

    this.varilladoOriginal = medicion.varillado;
    this.temperaturaOriginal = medicion.temperatura;
    this.nivelAguaOriginal = medicion.nivelAgua

    if (this.medicionRecibida) this.fechaHoraMedicionCintelink = this.medicionRecibida.fechaHoraMedicion;
  }

  vaciarCampos(): void {
    this.cantidad15FormControl.setValue('');
    this.cantidadNaturalFormControl.setValue('');
    this.nivelVarilladoFormControl.setValue('');
    this.temperaturaFormControl.setValue('');
    this.densidadFormControl.setValue('');
    this.nivelDeAguaFormControl.setValue('');
  }

  verificarGraduacion(i: number) {
    if (!this.tanques[i].tieneGraduacion) {
      this.form.controls.nivelVarilladoFormControl.setValidators(null);
      this.tanqueGraduacion = false;
    } else {
      this.form.controls.nivelVarilladoFormControl.setValidators([Validators.required]);
      this.tanqueGraduacion = true;
    }
    this.form.controls.nivelVarilladoFormControl.updateValueAndValidity();
  }

  onBlurNivelVarillado() {
    this.mostrarMensajeAlerta = false;
  }
  mostrarAlertaVarillado() {
    this.mostrarMensajeAlerta = true;
  }
  onBlurTemperatura() {
    this.recalcularVolumenNatural();
  }

  getAbastecedoras() {
    this.obteniendoAbastecedoras = true;
    this.abastecedoraService.getAbastecedoras(this.usuarioService.getAeroplantaActual().codigoAeroplanta)
      .subscribe(result => {
        this.abastecedoras = result;
        this.obteniendoAbastecedoras = false;
      })
  }

  leerArchivo(): string {
    const archivoTXT = new XMLHttpRequest();
    const fileRuta: string = 'assets/json/1.txt';
    archivoTXT.open("GET", fileRuta, false);
    archivoTXT.send(null);
    const response: any = archivoTXT.responseText;
    return response;
  }

  onBlurDensidad() {
    this.recalcularVolumenNatural();
  }

  densidadValida() {
    const raw = this.densidadFormControl.value;
    if (!raw || raw.toString().trim() === '') return true; 
    if (!this.productoSeleccionado) return true;

    const valorDensidad = Number(String(raw).replace(',', '.'));

    const { densidadMin, densidadMax } = this.productoSeleccionado;

    if (isNaN(valorDensidad)) return true;

    return valorDensidad >= densidadMin && valorDensidad <= densidadMax;
  }

  formatDensidad(event) {
    if (event.charCode == 8 || event.charCode == 0) return null;

    if (event.charCode >= 48 && event.charCode <= 57) {
      this.densidadFormControl.setValue(this.sharedService.formatDensidad(event));
      this.validarDensidad(this.densidadFormControl.value);
    }
    this.onBlurDensidad();
    return false;
  }

  validarDensidad(densidadFormControl: any): boolean {
    if (!densidadFormControl || !this.tanqueFormControl.value) return true;

    this.productoSeleccionado = this.productos.find(
      p => p.codigoProducto === this.tanqueFormControl.value.productoActual?.codigoProducto
    );
    if (!this.productoSeleccionado) return true;

    const dens = Number(String(densidadFormControl).replace(',', '.'));
    const min = Number(this.productoSeleccionado.densidadMin);
    const max = Number(this.productoSeleccionado.densidadMax);

    this.esDensidadMin = min.toFixed(3);
    this.esDensidadMax = max.toFixed(3);

    this.esValidaDensidad = dens >= min && dens <= max;
    return this.esValidaDensidad;
  }


  recalcularVolumenes() {
    this.medicionesParaTanque = true;
    const varillado = this.nivelVarilladoFormControl.value;
    const dens = this.densidadFormControl.value;
    const temp = this.temperaturaFormControl.value;

    if (this.tanqueFormControl.value != null && varillado != '') {
      this.calculandoCantidadNeta = true;
      this.stockService.getConversionLitrosPorVarillado(this.tanqueFormControl.value.codigo, varillado)
        .subscribe(volumenLts => {
          this.cantidadNaturalFormControl.setValue(volumenLts);
          if (dens != '' && temp != '') {
            this.cantidad15FormControl.setValue(this.calculoService.obtenerCTLNuevo(temp, dens, volumenLts));
          }
          this.calculandoCantidadNeta = false;
        },
          () => {
            this.cantidadNaturalFormControl.setValue('');
            this.calculandoCantidadNeta = false;
            this.medicionesParaTanque = false;
          });
    }
  }

  recalcularVolumenNatural() {
    const volumenLts = Number(this.cantidadNaturalFormControl.value);
    const dens = Number(String(this.densidadFormControl.value).replace(',', '.'));
    const temp = this.temperaturaFormControl.value;

    if (typeof volumenLts == 'number' && typeof dens == 'number' && temp != '') {
      console.log(this.calculoService.obtenerCTLNuevo(temp, dens, volumenLts));
      console.log(temp, dens, volumenLts)
      this.cantidad15FormControl.setValue(this.calculoService.obtenerCTLNuevo(temp, dens, volumenLts));
    }
  }

  // getters
  get tanqueFormControl() {
    return this.form.controls.tanqueFormControl;
  }

  get abastecedora() {
    return this.form.controls.abastecedoraFormControl;
  }

  get cantidad15FormControl() {
    return this.form.controls.cantidad15FormControl;
  }

  get cantidadNaturalFormControl() {
    return this.form.controls.cantidadNaturalFormControl;
  }

  get nivelVarilladoFormControl() {
    return this.form.controls.nivelVarilladoFormControl;
  }

  get temperaturaFormControl() {
    return this.form.controls.temperaturaFormControl;
  }

  get densidadFormControl() {
    return this.form.controls.densidadFormControl;
  }

  get nivelDeAguaFormControl() {
    return this.form.controls.nivelDeAguaFormControl;
  }

  get fechaFormControl() {
    return this.form.controls.fechaFormControl;
  }

  get horaFormControl() {
    return this.form.controls.horaFormControl;
  }
}
